import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
import { Facility } from '@/entities/Facility'
const requestService = new RequestService()

export class FacilityRequests {
  list () {
    const route = ServerDirections.FACILITIES
    const method = 'get'
    function map (data) {
      return data.map(item => new Facility(item))
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
